// Socrates: la transcripcion de los dialogos.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { api } from "./client";

// ---- Diálogos con Sócrates (transcripción) ----

export const getConversation = (sessionId) =>
  api.get(`/memory/conversation/${sessionId}`).then((r) => r.data);

// ---- Test de afinidad: con que mentor encajas ----
//
// Son TRES llamadas y no una a proposito. Una sola -«manda respuestas, te asigno mentor»-
// haria que el alumno recibiera un personaje sin haber tenido voz, y con alguien con quien
// va a hablar media hora al dia eso es justo lo que no queremos. Aqui el servidor propone,
// y entre `calculaAfinidad` y `eligeMentor` hay una pantalla donde decide una persona.

// Los cinco, para poder pintar el que ya tiene: la cuenta guarda la CLAVE -«A1»- y con una
// letra no se dibuja nada.
export const catalogoMentores = async () => {
  const { data } = await api.get("/mentor/catalogo");
  return data?.mentores ?? [];
};

// Las preguntas vienen SIN los pesos: un alumno que ve cuanto puntua cada opcion deja de
// responder lo que prefiere y empieza a responder para que le toque el que le hace gracia.
export const preguntasAfinidad = async () => {
  const { data } = await api.get("/mentor/afinidad");
  return data?.preguntas ?? [];
};

// Los que mas encajan. NO guarda nada: aqui todavia no ha decidido.
export const calculaAfinidad = async (respuestas) => {
  const { data } = await api.post("/mentor/afinidad", { respuestas });
  return data?.propuestos ?? [];
};

// Con cual se queda. Se puede volver a llamar: nadie queda atrapado con un mentor que
// eligio por probar y que a la tercera leccion no aguanta.
export const eligeMentor = async (clave) => {
  const { data } = await api.put("/mentor/elegido", { clave });
  return data;
};
